import React from "react";
import { Helmet } from "react-helmet";
import "../styles/Privacy.css";

export default function Privacy() {
  return (
    <main className="privacy-container">
      <Helmet>
        <title>Privacy Policy | Lash With Brittany</title>
        <meta name="description" content="Privacy policy for Lash With Brittany. Learn how we collect, use, and protect your information when you book or contact us." />
        <meta property="og:title" content="Privacy Policy | Lash With Brittany" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://lashwithbrittany.com/privacy" />
      </Helmet>

      <section className="privacy-hero">
        <div className="privacy-shell">
          <h1>Privacy Policy</h1>
          <p className="lead">Last updated: December 17, 2025</p>

          <article className="privacy-content">
            <h2>Information We Collect</h2>
            <p>
              We collect only the information necessary to provide services and
              communicate with you — name, email, phone number, and any booking
              details you provide. We also collect non-identifying usage data to
              improve the site.
            </p>

            <h2>How We Use Your Information</h2>
            <p>
              Your information is used to manage appointments, respond to
              inquiries, and send transactional messages. We do not sell your
              personal data.
            </p>

            <h2>Third Parties</h2>
            <p>
              We use trusted third-party services for booking and email (Ovatu,
              EmailJS). These providers have their own privacy policies; please
              review them for details.
            </p>

            <h2>Cookies & Tracking</h2>
            <p>
              We use cookies and analytics for site functionality and to measure
              performance. You may opt out of analytics via your browser settings.
            </p>

            <h2>Contact</h2>
            <p>If you have questions about this policy, email lashwithbrittany@gmail.com.</p>
          </article>
        </div>
      </section>
    </main>
  );
}
